import { Plus, Trash2, Copy, ChevronUp, ChevronDown } from "lucide-react";

const blankSlide = (theme) => ({ id: `s${Date.now()}`, layout: "title-content", theme, title: "", bullets: [], bulletStyle: "dot", body: "", background: null, image: null, chart: null, table: null, video: null, animation: "none", transition: "none", notes: "" });

export default function SlideRail({ doc, setDoc, config }) {
  const active = doc.activeSlide || 0;
  const slides = doc.slides;
  const n = slides.length;

  const addSlide = () => setDoc({ ...doc, slides: [...slides, blankSlide(slides[active].theme)], activeSlide: n });
  const duplicateSlide = () => {
    const copy = { ...JSON.parse(JSON.stringify(slides[active])), id: `s${Date.now()}` };
    const next = [...slides.slice(0, active + 1), copy, ...slides.slice(active + 1)];
    setDoc({ ...doc, slides: next, activeSlide: active + 1 });
  };
  const deleteSlide = () => { if (n <= 1) return; setDoc({ ...doc, slides: slides.filter((_, i) => i !== active), activeSlide: Math.max(0, active - 1) }); };
  const move = (dir) => {
    const j = active + dir;
    if (j < 0 || j >= n) return;
    const next = [...slides];
    [next[active], next[j]] = [next[j], next[active]];
    setDoc({ ...doc, slides: next, activeSlide: j });
  };

  const btn = "h-8 rounded-md bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 disabled:opacity-40 flex items-center justify-center gap-1 text-xs";
  return (
    <div className="flex lg:flex-col gap-2 lg:w-28 shrink-0 overflow-x-auto">
      {slides.map((s, i) => {
        const th = config.themes.find((t) => t.id === s.theme) || config.themes[0];
        const bg = (config.backgrounds || []).find((b) => b.id === s.background);
        return (
          <button key={s.id} data-testid={`slide-thumb-${i}`} onClick={() => setDoc({ ...doc, activeSlide: i })}
            className={`shrink-0 w-24 lg:w-full aspect-video rounded-md border-2 text-[9px] p-1.5 text-left overflow-hidden relative ${i === active ? "border-[#22D3EE]" : "border-transparent"}`}
            style={{ background: bg ? bg.color : th.bg, color: bg ? bg.fg : th.fg }}>
            <span className="absolute top-0.5 right-1 opacity-60">{i + 1}</span>
            <span className="font-bold block truncate pr-3">{s.title || `Slide ${i + 1}`}</span>
          </button>
        );
      })}
      <div className="grid grid-cols-2 gap-1.5 w-24 lg:w-full shrink-0">
        <button data-testid="slide-add" onClick={addSlide} className={`${btn} col-span-2`} title="New slide"><Plus className="w-3.5 h-3.5" /> Slide</button>
        <button data-testid="slide-duplicate" onClick={duplicateSlide} className={btn} title="Duplicate slide"><Copy className="w-3.5 h-3.5" /></button>
        <button data-testid="slide-delete" onClick={deleteSlide} disabled={n <= 1} className={`${btn} hover:text-red-500`} title="Delete slide"><Trash2 className="w-3.5 h-3.5" /></button>
        <button data-testid="slide-move-up" onClick={() => move(-1)} disabled={active === 0} className={btn} title="Move slide earlier"><ChevronUp className="w-3.5 h-3.5" /></button>
        <button data-testid="slide-move-down" onClick={() => move(1)} disabled={active >= n - 1} className={btn} title="Move slide later"><ChevronDown className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  );
}
